import { getSignup } from '../api/signupApi';
import { useSwal } from '../../../../components/Notifications/swal/SwalCom';
import { useNavigate } from 'react-router-dom';

const useSignup = () => {
    const { swalSuccess, swalFail, swalClose } = useSwal();
    const navigate = useNavigate();

    const handleSignup = async (params) => {
        swalSuccess("<b>Info</b>", "<p>Creating your account...</p>");
        const name = params?.name || '';
        const email = params?.email || '';
        const password = params?.password || '';
        
        try {
            const signupParams = { name, email, password };
            const signupRes = await getSignup(signupParams);
            swalClose();
            
            if (signupRes && signupRes.status === "success") {
                swalSuccess("<b>Success</b>", "<p>Account created successfully! Redirecting to login...</p>");
                setTimeout(() => {
                    navigate('/Login');
                }, 1500);
            } else {
                swalFail("<b>Warning</b>", `<p>${signupRes?.message || "Failed to create account. Please try again!"}</p>`);
            }
        } catch (error) {
            console.error('Signup Error:', error);
            swalFail("<b>Error</b>", `<p>${error?.response?.data?.message || "Failed to create account. Please try again later."}</p>`);
        }
    };

    const handleSignupError = (message) => {
        swalFail("<b>Validation Error</b>", `<p>${message}</p>`);
    };

    const handlers = {
        onSignup: async (params) => {
            await handleSignup(params);
        },
        onSignupError: (message) => {
            handleSignupError(message);
        }
    };
    
    return {
        handlers,
    };
};

export default useSignup;

